import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appendTimezone, timestampRangeString } from "../../../lib/date";
import Image from "../../Image";
import { formatNumber } from "../../../lib/number";
import Metric from "../../Metric";
import Tooltip from "..";
import ViewSessionsAction from "../../ChartTooltipAction/ViewSessionsAction";
import CompareSessionsAction from "../../ChartTooltipAction/CompareSessionsAction";
import style from "./style.module.scss";
export default function MapTooltip(props) {
    const point = props.point;
    const series = point.series.userOptions;
    //Display the country flag if supplied.
    let countryFlag = null;
    if (point.code) {
        const flagImage = `img/country-flags/${point.code.toLowerCase()}.png`;
        countryFlag = _jsx(Image, { path: flagImage, width: 16 });
    }
    //Work out which colour to show in the tool tip. If a colour has been set on the point use that, if not fall back to the colour set on the series. Default is our base High Contrast colour.
    let metricColor = "";
    if (point.color) {
        metricColor = point.color;
    }
    else if (series.color) {
        metricColor = series.color;
    }
    const metricName = series.metricName;
    const metricSuffix = series.suffix;
    const pageViews = series.metric === "pvs" ? null : _jsxs("div", { children: [formatNumber(point.num), " page views"] });
    const number = formatNumber(point.y);
    const actionsList = [
        _jsx(ViewSessionsAction, { type: "map", point: point }, "view-sessions"),
        _jsx(CompareSessionsAction, { type: "map", point: point }, "compare-sessions"),
    ];
    return (_jsxs(Tooltip, { footer: actionsList, children: [_jsxs("div", { className: style["country"], children: [_jsx("span", { children: point.location }), _jsx("span", { className: style["country__flag"], children: countryFlag })] }), appendTimezone(timestampRangeString(series.startTime, series.endTime)), " ", pageViews, _jsx(Metric, { color: metricColor, title: metricName, value: `${number}${metricSuffix}` })] }));
}
